import {ToastContainer} from 'react-toastify'
import React, {useState} from 'react'
import {KTCard, KTCardBody} from '../../../_websoft/helpers'
import {imaLiAktivanZapis} from '../../api/radniNalozi'
import notifyToast from '../../components/Toast/Toast'
import {useNavigate} from 'react-router-dom'

const TerminaliDashboard: React.FC = () => {
    const navigate = useNavigate()
    const [loading, setLoading] = useState(false)

    const onRadniKrajClick = () => {
        setLoading(true)
        imaLiAktivanZapis()
            .then((response) => {
                if (response.data.Id) {
                    navigate(`/terminali/radni-nalozi/${response.data.Id}`)
                }
            })
            .catch((error) => {
                notifyToast(false, error.message)
                navigate(`/terminali/radni-nalog-start/pocetna`)
            })
            .finally(() => setLoading(false))
    }

    const onZaduzeniMaterijalClick = () => {
        navigate('/terminali/zaduzeni-materijal')
    }

    const handleMojeAktivnosti = () => {
        notifyToast(false, 'trenutno nije dostupno.')
    }

    // tiny helper (inline, not reusable component)
    const tileBase =
        'card hoverable border-0 shadow-sm h-100 text-white text-start overflow-hidden position-relative'

    const tileBody = 'card-body p-4 p-md-5 d-flex flex-column justify-content-between'

    const titleCls = 'fw-bolder mb-2'
    const subCls = 'opacity-75 fw-semibold'

    return (
        <KTCard>
            <ToastContainer />
            <KTCardBody className='py-4'>
                <div className='container-fluid px-0 px-md-3'>
                    {/* Header */}
                    <div className='d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 mb-4'>
                        <div>
                            <div className='text-muted fw-semibold mb-1'>Terminal</div>
                            <h1 className='fw-bolder text-gray-900 mb-0'>Glavni meni</h1>
                            <div className='text-muted mt-2'>
                                Brz pristup ključnim modulima. Na mobitelu su kartice veće i lakše za klik.
                            </div>
                        </div>

                        <div className='d-flex align-items-center gap-2'>
                            {loading ? (
                                <span className='badge bg-light text-dark d-inline-flex align-items-center gap-2 p-3'>
                  Učitavanje…
                  <span className='spinner-border spinner-border-sm' />
                </span>
                            ) : (
                                <span className='badge bg-light text-dark p-3'>
                  Status: <span className='fw-bold'>Spremno</span>
                </span>
                            )}
                        </div>
                    </div>

                    {/* Main grid */}
                    <div className='row g-4'>
                        {/* LEFT GROUP */}
                        <div className='col-12 col-lg-4'>
                            <div className='card border-0 shadow-sm h-100'>
                                <div className='card-body p-3 p-md-4'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='text-muted small'>Radni nalozi</div>
                                            <div className='fw-bolder fs-4'>Start / Kraj / FMK</div>
                                        </div>
                                        <span className='badge bg-light text-dark'>WEBSOFT</span>
                                    </div>

                                    {/* Start/Kraj row */}
                                    <div className='row g-3'>
                                        <div className='col-12 col-sm-6'>
                                            <button
                                                onClick={onRadniKrajClick}
                                                disabled={loading}
                                                className={`${tileBase} w-100`}
                                                style={{
                                                    background: 'linear-gradient(135deg, #54bda3 0%, #2f9f87 100%)',
                                                    borderRadius: 14,
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>START</div>
                                                        <i className='bi bi-play-fill fs-2 opacity-75' />
                                                    </div>

                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Radni nalog</div>
                                                        <div className={subCls}>Pokreni, pauziraj ili zavrsi radni nalog</div>
                                                    </div>

                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-lightning-charge-fill' />
                                                        <span className='fw-semibold'>Otvori modul</span>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>

                                        <div className='col-12 col-sm-6'>
                                            <button
                                                onClick={onZaduzeniMaterijalClick}
                                                disabled={loading}
                                                className={`${tileBase} w-100`}
                                                style={{
                                                    background: 'linear-gradient(135deg, #ee3e3e 0%, #b81f1f 100%)',
                                                    borderRadius: 14,
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>KRAJ</div>
                                                        <i className='bi bi-stop-fill fs-2 opacity-75' />
                                                    </div>

                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Zaduzeni materijal</div>
                                                        <div className={subCls}>Izvrsi promet zaduzenog materijala</div>
                                                    </div>

                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-shield-check' />
                                                        <span className='fw-semibold'>Otvori modul</span>
                                                    </div>
                                                </div>
                                            </button>
                                        </div>

                                        {/* FMK actions */}
                                        <div className='col-12'>
                                            <a
                                                href='radni-nalozi/pocetna'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #354f60 0%, #1f3442 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>FMK</div>
                                                        <i className='bi bi-list-check fs-2 opacity-75' />
                                                    </div>

                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Radni nalozi</div>
                                                        <div className={subCls}>Spremi nalog • Isporuči nalog</div>
                                                    </div>

                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-arrow-right-circle' />
                                                        <span className='fw-semibold'>Otvori modul</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        {/* Kvar - create */}
                                        <div className='col-12'>
                                            <a
                                                href='prijava-kvara/dodaj'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #545454 0%, #2f2f2f 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>KVAR</div>
                                                        <i className='bi bi-tools fs-2 opacity-75' />
                                                    </div>

                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Kreiraj prijavu kvara</div>
                                                        <div className={subCls}>Urgentna / redovna prijava</div>
                                                    </div>

                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-exclamation-triangle' />
                                                        <span className='fw-semibold'>Važno</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* MIDDLE GROUP */}
                        <div className='col-12 col-lg-5'>
                            <div className='card border-0 shadow-sm h-100'>
                                <div className='card-body p-3 p-md-4'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='text-muted small'>Materijal / proizvodnja</div>
                                            <div className='fw-bolder fs-4'>Moduli</div>
                                        </div>
                                        <span className='badge bg-light text-dark'>WEBSOFT</span>
                                    </div>

                                    <div className='row g-3'>
                                        <div className='col-12'>
                                            <a
                                                href='repromaterijali'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #504165 0%, #2f2441 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>REPR</div>
                                                        <i className='bi bi-box-seam fs-2 opacity-75' />
                                                    </div>
                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Repromaterijali</div>
                                                        <div className={subCls}>Lista • Promet • Rolne u dolasku</div>
                                                    </div>
                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-arrow-right-circle' />
                                                        <span className='fw-semibold'>Otvori modul</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        <div className='col-12'>
                                            <a
                                                href='termopaneli'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #30293b 0%, #1a1621 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>TP</div>
                                                        <i className='bi bi-building fs-2 opacity-75' />
                                                    </div>
                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Termoizolacioni paneli</div>
                                                        <div className={subCls}>
                                                            Proizvodnja • Trebovanje • Knjiga • Nalozi • Izvještaji
                                                        </div>
                                                    </div>
                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-arrow-right-circle' />
                                                        <span className='fw-semibold'>Otvori modul</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        <div className='col-12'>
                                            <a
                                                href='artikal/pocetna'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #30293b 0%, #1a1621 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>ART</div>
                                                        <i className='bi bi-tags fs-2 opacity-75' />
                                                    </div>
                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Artikli</div>
                                                        <div className={subCls}>Lista artikala • palete • promet</div>
                                                    </div>
                                                    <div className='mt-4 d-flex align-items-center gap-2 opacity-75'>
                                                        <i className='bi bi-arrow-right-circle' />
                                                        <span className='fw-semibold'>Otvori modul</span>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* RIGHT GROUP */}
                        <div className='col-12 col-lg-3'>
                            <div className='card border-0 shadow-sm h-100'>
                                <div className='card-body p-3 p-md-4'>
                                    <div className='d-flex align-items-center justify-content-between mb-3'>
                                        <div>
                                            <div className='text-muted small'>Ostalo</div>
                                            <div className='fw-bolder fs-4'>Dodatne opcije</div>
                                        </div>
                                        <span className='badge bg-light text-dark'>WEBSOFT</span>
                                    </div>

                                    <div className='row g-3'>
                                        <div className='col-12'>
                                            <a
                                                href='dashboard-rasjecanje'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #4cb9c6 0%, #2a8f9b 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>RS</div>
                                                        <i className='bi bi-scissors fs-2 opacity-75' />
                                                    </div>
                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Rasjecanje / Odmotavanje</div>
                                                        <div className={subCls}>Dashboard</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        <div className='col-12'>
                                            <a
                                                href='galanterija/pocetna'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #538794 0%, #2d5f6a 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>GAL</div>
                                                        <i className='bi bi-grid-3x3-gap fs-2 opacity-75' />
                                                    </div>
                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Galanterija</div>
                                                        <div className={subCls}>Artikli</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>

                                        <div className='col-12'>
                                            <a
                                                href='prijedlozi-za-poboljsanje/dodaj'
                                                className={tileBase}
                                                style={{
                                                    background: 'linear-gradient(135deg, #7e2b2b 0%, #4a1414 100%)',
                                                    borderRadius: 14,
                                                    textDecoration: 'none',
                                                    display: 'block',
                                                }}
                                            >
                                                <div className={tileBody}>
                                                    <div className='d-flex align-items-center justify-content-between'>
                                                        <div className='badge bg-white text-dark fw-bold'>IDEJA</div>
                                                        <i className='bi bi-lightbulb fs-2 opacity-75' />
                                                    </div>
                                                    <div className='mt-4'>
                                                        <div className={`${titleCls} fs-3`}>Prijedlozi za poboljšanje</div>
                                                        <div className={subCls}>Kreiraj prijedlog</div>
                                                    </div>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Bottom row tiles */}
                        <div className='col-12'>
                            <div className='row g-4 mt-1'>
                                <div className='col-12 col-md-6 col-xl-3'>
                                    <a
                                        href='prijava-kvara/pocetna'
                                        className={tileBase}
                                        style={{
                                            background: 'linear-gradient(135deg, #8e8e8e 0%, #5a5a5a 100%)',
                                            borderRadius: 14,
                                            textDecoration: 'none',
                                            display: 'block',
                                        }}
                                    >
                                        <div className={tileBody}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='badge bg-white text-dark fw-bold'>KVAR</div>
                                                <i className='bi bi-wrench-adjustable fs-2 opacity-75' />
                                            </div>
                                            <div className='mt-4'>
                                                <div className={`${titleCls} fs-3`}>Prijave kvarova</div>
                                                <div className={subCls}>Kvarovi • Intervencije • Preuzmi kvar</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className='col-12 col-md-6 col-xl-3'>
                                    <a
                                        href='zahtjev-za-nabavu/dodaj'
                                        className={tileBase}
                                        style={{
                                            background: 'linear-gradient(135deg, #307a70 0%, #1d4f48 100%)',
                                            borderRadius: 14,
                                            textDecoration: 'none',
                                            display: 'block',
                                        }}
                                    >
                                        <div className={tileBody}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='badge bg-white text-dark fw-bold'>NABAVA</div>
                                                <i className='bi bi-cart-plus fs-2 opacity-75' />
                                            </div>
                                            <div className='mt-4'>
                                                <div className={`${titleCls} fs-3`}>Zahtjev za nabavu</div>
                                                <div className={subCls}>Kreiraj • Pregled zahtjeva</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className='col-12 col-md-6 col-xl-3'>
                                    <a
                                        href='viljuskari/pocetna'
                                        className={tileBase}
                                        style={{
                                            background: 'linear-gradient(135deg, #54bda3 0%, #2f9f87 100%)',
                                            borderRadius: 14,
                                            textDecoration: 'none',
                                            display: 'block',
                                        }}
                                    >
                                        <div className={tileBody}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='badge bg-white text-dark fw-bold'>VILJUSKARI</div>
                                                <i className='bi bi-truck-front fs-2 opacity-75' />
                                            </div>
                                            <div className='mt-4'>
                                                <div className={`${titleCls} fs-3`}>Viljuškari</div>
                                                <div className={subCls}>Zapis rada • Intervencije</div>
                                            </div>
                                        </div>
                                    </a>
                                </div>

                                <div className='col-12 col-md-6 col-xl-3'>
                                    <a
                                        onClick={handleMojeAktivnosti}
                                        className={tileBase}
                                        style={{
                                            cursor: 'pointer',
                                            background: 'linear-gradient(135deg, #c24a22 0%, #7a2a12 100%)',
                                            borderRadius: 14,
                                            textDecoration: 'none',
                                            display: 'block',
                                        }}
                                    >
                                        <div className={tileBody}>
                                            <div className='d-flex align-items-center justify-content-between'>
                                                <div className='badge bg-white text-dark fw-bold'>IZVJESTAJ</div>
                                                <i className='bi bi-activity fs-2 opacity-75' />
                                            </div>
                                            <div className='mt-4'>
                                                <div className={`${titleCls} fs-3`}>Moje aktivnosti</div>
                                                <div className={subCls}>Tekući mjesec</div>
                                            </div>
                                            <div className='mt-3 text-white opacity-75 small'>
                                                Galanterija • Proizvodnja jedn. limova
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>

                        {/* VERY IMPORTANT NOTICE */}
                        <div className='col-12 mt-6'>
                            <div
                                className='alert alert-danger d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3 shadow-sm mb-0'
                                style={{borderRadius: 14}}
                            >
                                <div className='d-flex align-items-start gap-3'>
                                    <div
                                        className='rounded-circle d-flex align-items-center justify-content-center'
                                        style={{
                                            width: 44,
                                            height: 44,
                                            background: 'rgba(220,53,69,0.12)',
                                            flex: '0 0 auto',
                                        }}
                                    >
                                        <i className='bi bi-exclamation-triangle-fill text-danger fs-4' />
                                    </div>

                                    <div>
                                        <div className='fw-bolder fs-4 text-danger mb-1'>VAŽNO</div>
                                        <div className='fw-semibold text-gray-900'>
                                            Sve akcije se snimaju u sistemu, vodite računa o tome!
                                        </div>
                                        <div className='text-muted small mt-1'>
                                            Ne dijelite pristupne podatke i uvijek provjerite modul prije potvrde.
                                        </div>
                                    </div>
                                </div>

                                <div className='d-flex align-items-center gap-2'>
                                    <span className='badge bg-danger p-3'>Audit log ON</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </KTCardBody>
        </KTCard>
    )
}

export default TerminaliDashboard
